import React from 'react';
import './Services.css';

const Services = ({ language }) => {
  const translations = {
    en: {
      title: 'WHAT WE DELIVER',
      services: [
        {
          icon: '🏢',
          title: 'ATM Transport & Installation',
          description: 'Secure, professional transportation and installation of ATMs with full logistical support, specialized handling, and compliance management.',
        },
        {
          icon: '🛠️',
          title: 'ATM Room Preparation',
          description: 'Complete preparation and setup services for ATM room installations, including site assessment, equipment placement, and operational readiness.',
        },
        {
          icon: '📦',
          title: 'Prepaid Shipment Solutions',
          description: 'Reliable shipping options with tracking, insurance, and customizable delivery schedules for secure and timely deliveries.',
        },
        {
          icon: '🚚',
          title: 'Local Cargo & Logistics',
          description: 'Dependable local freight forwarding, cargo management, and logistics solutions with comprehensive coverage and real-time monitoring.',
        },
      ],
    },
    ar: {
      title: 'ما نقدمه',
      services: [
        {
          icon: '🏢',
          title: 'نقل وتثبيت الصرافات الآلية',
          description: 'نقل آمن واحترافي وتثبيت الصرافات الآلية مع الدعم اللوجستي الكامل والمعالجة المتخصصة وإدارة الامتثال.',
        },
        {
          icon: '🛠️',
          title: 'تحضير غرف الصرافات الآلية',
          description: 'خدمات تحضير وإعداد شاملة لغرف الصرافات الآلية، تشمل تقييم الموقع وتحديد موقع المعدات والجاهزية التشغيلية.',
        },
        {
          icon: '📦',
          title: 'حلول الشحن المدفوع مقدمًا',
          description: 'خيارات شحن موثوقة مع التتبع والتأمين والجداول الزمنية القابلة للتخصيص للتسليمات الآمنة والسريعة.',
        },
        {
          icon: '🚚',
          title: 'البضائع المحلية واللوجستيات',
          description: 'خدمات نقل وإدارة بضائع محلية موثوقة مع تغطية شاملة والمراقبة في الوقت الفعلي.',
        },
      ],
    },
  };

  const t = translations[language];

  return (
    <section className="services" id="services">
      <div className="services-container">
        <h2 className="services-title">{t.title}</h2>
        <div className="services-grid">
          {t.services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
